/* globals MktoForms2 */

import $ from 'jquery';
import parseParameters from '../twig/helpers/parse-parameters';
import user from '../twig/helpers/user-info';
import mktoPrefill from '../twig/vue/components/marketo/marketo-prefill';
import {
  MARKETO_GA_GUID_FIELD_NAME,
  getGaGuidAsync
} from '../twig/vue/components/form/fields/field-ga-guid';

const mktoSetup = {
  subIdOnSuccess(form) {
    const parameters = parseParameters(window.location.search);
    if (parameters.subid === undefined) {
      return;
    }

    form.onSuccess(() => {
      const pixel = `
        <img
          height="1"
          width="1"
          style="display:none"
          src="http://api.naturaltracking.com/api/server_to_server_events/track/?aff_sid1=${parameters.subid}"
        >
      `;
      $('body').append(pixel);
    });
  },

  disableDefaultStyles(form) {
    const formEls = form.getFormElem()[0];
    formEls.removeAttribute('style');
    for (
      let elsWithStyles = formEls.querySelectorAll('[style]'),
        i = 0,
        imax = elsWithStyles.length;
      i < imax;
      i++
    ) {
      elsWithStyles[i].removeAttribute('style');
    }
    if (document.getElementById('mktoForms2BaseStyle')) {
      document.getElementById('mktoForms2BaseStyle').remove();
    }

    if (document.getElementById('mktoForms2ThemeStyle')) {
      document.getElementById('mktoForms2ThemeStyle').remove();
    }
  },

  setPlaceholderColors(form) {
    function setColor() {
      const selectColor = this.value === '' ? '#BABFC6' : '#7a7a7a';
      return this.setAttribute('style', `color: ${selectColor}`);
    }
    const formEls = form.getFormElem();
    const selEls = formEls.find('select');
    selEls.on('change', setColor);
  },

  selectDefaultMessage() {
    const mktoForm = $('.mktoForm');
    const mktoOption = mktoForm.find('select option:first-child');
    if (!mktoForm.is('.mktoGhost, .mktoSolid, .mktoSolid--v2, .mktoSteps')) {
      $(mktoOption).html('Select...');
    }
  },

  analyticsOnSuccess(form) {
    form.onSuccess(() => {
      window.optimizely.push({
        type: 'event',
        eventName: 'form-submit'
      });
    });
  },

  setCheckboxLabel() {
    if (document.querySelector('.mktoCheckboxList')) {
      const checkbox = document.querySelector('.mktoCheckboxList');
      const checkboxLabel = checkbox.parentNode
        .querySelector('label')
        .innerText.replace('*', '');
      const checkboxLabelTarget = checkbox.querySelector('label');
      checkboxLabelTarget.innerText = checkboxLabel;
    }
  },

  optionDisable(form) {
    $(form.getFormElem)
      .find('select option:first-child')
      .prop('disabled', true);
  },

  isEmailValid(email) {
    const invalidEmails = [
      'none@none.com',
      'noemail@noemail.com',
      'none@gmail.com',
      'none@yahoo.com',
      'none@hotmail.com',
      'none@aol.com',
      'noemail@gmail.com',
      'noemail@yahoo.com',
      'noemail@hotmail.com',
      'noemail@aol.com',
      'na@na.com',
      'no@no.com',
      'no@none.com',
      'example@yourdomain.com'
    ];
    for (let i = 0; i < invalidEmails.length; i++) {
      const domain = invalidEmails[i];
      if (email.indexOf(domain) !== -1) {
        return false;
      }
    }

    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+[^.]\.[A-Z]{2,}$/i.test(email);
  },

  validateEmail(form) {
    form.onValidate(() => {
      const email = form.vals().Email;
      if (email) {
        if (!mktoSetup.isEmailValid(email)) {
          form.submitable(false);
          const emailElem = form.getFormElem().find('#Email');
          form.showErrorMessage('Must be a valid email', emailElem);
          if ($(emailElem).offset().top - $(window).scrollTop() < 40) {
            $('html, body').animate(
              {
                scrollTop: $(emailElem).offset().top - 200
              },
              500
            );
          }
        } else {
          form.submitable(true);
        }
      }
    });
  },

  fixSelectFlicker(form) {
    const selEls = form.getFormElem()[0].querySelectorAll('SELECT');
    if (window.chrome && window.chrome.runtime && navigator.credentials) {
      // Chrome 51+
      [].forEach.call(selEls, (el) => {
        el.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    }
  },

  setUserTimezone(form) {
    if ($(form.getFormElem()).find('input[name="Timezone__c"]')) {
      const timezone = `${user.timezone.name} (${user.timezone.location}, ${user.timezone.offset})`;
      form.vals({ Timezone__c: timezone });
    }
  },

  setUserDevice(form) {
    if ($(form.getFormElem()).find('input[name="User_Agent__c"]')) {
      const userdevice = `
        browser: ${user.browser.name},
        browserVersion: ${user.browser.version},
        browserEngine: ${user.browser.engine},
        device: ${user.device.name},
        deviceType: ${user.device.type},
        os: ${user.os.name},
        osVersion: ${user.os.version},
        userAgent: ${user.agent}
      `;
      form.vals({ User_Agent__c: userdevice });
    }
  },

  setLeadSubmissionUrl(form) {
    if (form.getFormElem().find('input[name="Lead_Submission_URL__c"]')) {
      form.vals({
        Lead_Submission_URL__c: window.location.host + window.location.pathname
      });
    }
  },

  setGaGuid(form) {
    getGaGuidAsync((gaGuid) => {
      form.vals({ [MARKETO_GA_GUID_FIELD_NAME]: gaGuid });
    });
  },

  init() {
    if (!('MktoForms2' in window)) return;

    MktoForms2.whenReady((form) => {
      mktoPrefill.init(form);
      mktoSetup.disableDefaultStyles(form);
      mktoSetup.subIdOnSuccess(form);
      mktoSetup.analyticsOnSuccess(form);
      mktoSetup.validateEmail(form);
      mktoSetup.fixSelectFlicker(form);
      mktoSetup.setUserTimezone(form);
      mktoSetup.setUserDevice(form);
      mktoSetup.setLeadSubmissionUrl(form);
      mktoSetup.setCheckboxLabel();
      mktoSetup.setGaGuid(form);
    });

    MktoForms2.whenRendered((form) => {
      mktoSetup.selectDefaultMessage();
      mktoSetup.setPlaceholderColors(form);
      mktoSetup.optionDisable(form);
    });
  }
};

export default mktoSetup;
